module.exports = __webpack_public_path__ + "static/product-511fdd0c5faa52e36ce52de1ebe9ce69.jpg";